import ManageWishlist from '@/components/ui/buttons/manage-wishlist';
import Share from '@/components/ui/share';

const CtaButtons = ({ sku = '', title = '', description = '', product }) => {
  return (
    <div
      className='mt-5 flex items-center justify-center gap-6 absolute md:relative max-sm:start-0 max-sm:-top-3 max-sm:w-full'
    >
      <ManageWishlist sku={sku} product={product} />
      <Share title={title} description={description} />
    </div>
  );
};

export default CtaButtons;
